<template>
  <notes
    description="General Notes related to this Customer"
    :notableEntity="notableEntity"
  />
</template>
<script>
import notes from "@/components/Handi/Notes/Notes";

export default {
  props: {
    customer: Object
  },

  components: {
    notes
  },

  data() {
    return {
      entityType: "user"
    };
  },

  computed: {
    notableEntity() {
      return {
        entityType: this.entityType,
        entityId: this.customer.id
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
